/* istanbul ignore file */
import React from 'react';
import { useParams } from 'react-router-dom';
import { DeleteButton } from 'framework/ui/ui-builder';
import useSkillBasedQueueService, {
  DELETE_SKILL_BASED_QUEUE,
} from 'domain/gpo/skillBasedQueue/shared/skillBasedQueueService';
import { useSkillBasedQueueUrl } from 'domain/gpo/skillBasedQueue/skillBasedQueueRoute';

const deleteMessage = 'Do you really want to delete this Skill Based Queue?';

const DeleteSkillBasedQueueButton = () => {
  const { id: skillId } = useParams<Dictionary<string>>();
  const { deleteById } = useSkillBasedQueueService();
  const { getListUrl } = useSkillBasedQueueUrl();

  return (
    <DeleteButton
      deleteMethod={() => deleteById(skillId!)}
      displayMessage={deleteMessage}
      afterDelete={{
        redirectUrl: getListUrl(),
        successMessage: 'The Skill Based Queue has been successfully deleted.',
        errorMessage: `Can't delete Skill Based Queue`,
      }}
      permissionToCheck={DELETE_SKILL_BASED_QUEUE}
    />
  );
};

export default DeleteSkillBasedQueueButton;
